<template>
    <b-container fluid class="mt--7">
        <b-card>
            <b-card-header>
                <b-row>
                    <b-col cols="6">
                        <b-form-input
                            type="text"
                            placeholder="Filter..."
                            addon-right-icon="ni ni-zoom-split-in"
                            v-model="query"
                        ></b-form-input>
                    </b-col>

                    <b-col cols="6">
                        <slot></slot>
                    </b-col>
                </b-row>
            </b-card-header>

            <b-card-body>
                <p class="mt-3">
                    Page: {{ pagination.page }} of {{ pageCount }} Total:
                    {{ pagination.total }}
                </p>

                <b-table
                    id="customerTable"
                    :items="customers"
                    :fields="fields"
                    small
                    responsive
                >
                    <template #cell(id)="row">
                        <b-button
                            size="sm"
                            @click="viewCustomer(row.item.id)"
                            class="mr-2"
                            variant="primary"
                            v-if="hasPermissionView"
                        >
                            View
                        </b-button>
                    </template>
                </b-table>

                <b-row>
                    <b-col>
                        <b-pagination
                            class="float-right"
                            v-model="pagination.page"
                            :total-rows="pagination.total"
                            :per-page="pagination.pageSize"
                            aria-controls="customerTable"
                            pills
                            align="right"
                        ></b-pagination>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
    </b-container>
</template>
<script>
import _ from 'lodash'

import reportMixins from '@/mixins/reportMixins'
import popupMixins from '@/mixins/popupMixins'
import permissionsMixins from '@/mixins/permissionsMixins'

//import autoTable from 'jspdf-autotable'
export default {
    name: 'customers-table',
    mixins: [popupMixins, permissionsMixins, reportMixins],
    props: ['type', 'title'],
    data() {
        return {
            reportType: 'customer_details',
            query: '',
            template: false,
            fields: [
                { label: 'Actions', key: 'id' },
                'code',
                'name',
                'phone',
                'email',
            ],
        }
    },
    mounted() {
        if (this.$route.query.query) this.query = this.$route.query.query
        this.doSearch()
    },
    watch: {
        'pagination.page': function (newPage) {
            this.changePage(newPage)
        },
        report_loading: function (val) {
            this.$emit('report-state', val)
        },
        query: _.debounce(function (query) {
            this.$router.push({ query: { query } })
            this.doSearch()
        }, 200),
    },
    methods: {
        getQueryString(rpt_type) {
            const queryModel = {
                name: this.query,
                rpt_type,
            }
            return `&query=${btoa(JSON.stringify(queryModel))}`
        },

        changePage(page) {
            this.$router.push({ query: { page } })
            this.doSearch()
        },
        doSearch() {
            const {
                query,
                pagination: { page },
            } = this
            this.$store.dispatch('customers/fetch', {
                query,
                page,
            })
        },
        viewCustomer(id) {
            id = parseInt(id) || 0
            this.$router.push({ params: { id }, name: 'viewCustomer' })
        },
        deleteItem(id) {
            let item = this.customers.find(el => el.id == id)

            const title = 'Delete Customer?'
            const message = `Are you sure you want to delete customer.. ${item.name}?`
            this.confirmMessage(title, message).then(result => {
                if (result) {
                    this.$store
                        .dispatch('customers/delete', id)
                        .then(() => {
                            this.doToast(
                                'Deleted!',
                                'Customer has been deleted.',
                                'success'
                            )
                        })
                        .catch(error => {
                            console.error(error)
                            this.doToast(
                                'Error!',
                                'Unable to delete Customer!',
                                'danger'
                            )
                        })
                }
            })
        },
    },

    computed: {
        pageCount() {
            return Math.ceil(this.pagination.total / this.pagination.pageSize)
        },
        customers() {
            return this.$store.getters['customers/customers']
        },
        pagination() {
            return this.$store.state.customers.pagination || {}
        },
        user() {
            return this.$store.state.user
        },
    },
}
</script>
<style></style>
